import React, { useEffect, useState } from "react";
import { Table, Tooltip } from "antd";
import useWindowDimensions from "../WindowDimensions/WindowDimensions";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { ColumnsType, TablePaginationConfig } from "antd/es/table";
import { IManagerEmployeeResponseResults } from "../../types";
import s from "./Table.module.scss";
import { Link } from "react-router-dom";
import { AppDispatch } from "../../redux/store";
import { useDispatch } from "react-redux";
import { getManagerEmployeeDetails } from "../../redux/UserSlice";

interface TableType {
  id: number;
  number: number;
  name: string;
  email: string;
  phone: string;
  role?: string;
  is_active: string;
  email_verified: string;
  details: React.ReactNode;
}

interface TableProps {
  dataSource?: IManagerEmployeeResponseResults[] | undefined;
  pagination: TablePaginationConfig;
  onPageChange: (page: number) => void;
}

export const UserTable: React.FC<TableProps> = ({
  dataSource,
  pagination,
  onPageChange,
}) => {
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const dispatch: AppDispatch = useDispatch();

  const columns: ColumnsType<TableType> = [
    {
      title: "№",
      dataIndex: "number",
      width: 20,
      align: "center",
    },
    {
      title: t("ФИО пользователя"),
      dataIndex: `name`,
      width: 150,
    },
    {
      title: t("Email"),
      dataIndex: `email`,
      width: 100,
    },
    {
      title: t("Телефон"),
      dataIndex: `phone`,
      width: 100,
    },
    {
      title: t("Роль"),
      dataIndex: `role`,
      width: 50,
      align: "center",
    },
    {
      title: t("Активный"),
      dataIndex: `is_active`,
      width: 50,
      align: "center",
      render: (text) => (
        <div className={s.font}>
          {text === t("Да") ? (
            <CheckCircleOutlined className={s.green} />
          ) : (
            <CloseCircleOutlined className={s.red} />
          )}
        </div>
      ),
    },
    {
      title: t("Верифицирован"),
      dataIndex: `email_verified`,
      width: 50,
      align: "center",
      render: (text) => (
        <div className={s.font}>
          {text === t("Да") ? (
            <CheckCircleOutlined className={s.green} />
          ) : (
            <CloseCircleOutlined className={s.red} />
          )}
        </div>
      ),
    },
    {
      title: t("Информация"),
      dataIndex: `details`,
      align: "center",
      width: 20,
    },
  ];

  return (
    <Table<TableType>
      rowKey={(record) => record.id}
      columns={columns}
      dataSource={dataSource?.map((it, index) => ({
        id: it.id,
        number: index + 1,
        name: it.full_name,
        email: it.email,
        phone: it.phone,
        role: it.role,
        is_active: it.is_active ? "Да" : "Нет",
        email_verified: it.email_verified ? "Да" : "Нет",
        details: (
          <Link
            to={`/user/${it.id}`}
            className={s.edit}
            onClick={() => dispatch(getManagerEmployeeDetails(it.id))}
          >
            <Tooltip title={t("Просмотр/Редактирование")} key={1}>
              <EditOutlined />
            </Tooltip>
          </Link>
        ),
      }))}
      pagination={{
        ...pagination,
        size: width > 900 ? "default" : "small",
      }}
      onChange={(pagination) => {
        const page = pagination?.current ?? 1;
        onPageChange(page);
      }}
    />
  );
};
